var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersWithSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "url(#paint0_linear_4478_4384)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2353 28.6765L20.6471 24.0882M13.7647 24.0882V10.3235V24.0882ZM13.7647 10.3235L9.17651 14.9118L13.7647 10.3235ZM13.7647 10.3235L18.353 14.9118L13.7647 10.3235ZM25.2353 14.9118V28.6765V14.9118ZM25.2353 28.6765L29.8236 24.0882L25.2353 28.6765Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4478_4384",
    x1: 19.5,
    y1: 0,
    x2: 19.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED142"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWithSubscriptionIcon);
export default __webpack_public_path__ + "static/media/usersWithSubscriptionIcon.9cb01df010c9e90120d6e429c119d34d.svg";
export { ForwardRef as ReactComponent };